//const API_URL = "https://cors-everywhere-me.herokuapp.com/http://161.35.73.178:6868";

const API_URL = "http://localhost:6868";

//const API_URL = "https://foulplay.de"

import axios from "axios";
import {locale} from "svelte-i18n";

axios.defaults.baseURL = ENV_API_URL ?? API_URL;
if (window.localStorage.getItem("token")) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + window.localStorage.getItem("token");
}

export default axios;

let currentLocale = "de";
locale.subscribe(value => {
    if (value == null || value.includes("de")) {
        currentLocale = "de";
    } else {
        currentLocale = value;
    }
    axios.defaults.headers.common['Locale'] = currentLocale;
    console.log("Locale changed to " + currentLocale);
})

function getEntities(schemaName) {
    return axios.get("/api/" + schemaName + "/").then(response => {
        return response.data;
    });
}

function getEntity(schemaName, id) {
    return axios.get("/api/" + schemaName + "/" + id).then(response => {
        return response.data;
    });
}

function getEntitiesAdmin(schemaName) {
    return axios.get("/api/" + schemaName + "/", {headers: {"Locale": ""}}).then(response => {
        return response.data;
    });
}

function getEntityAdmin(schemaName, id) {
    return axios.get("/api/" + schemaName + "/" + id, {headers: {"Locale": ""}}).then(response => {
        return response.data;
    });
}

function createEntity(schemaName, entity) {
    return axios.post("/api/" + schemaName + "/", entity, {
        headers: {
            Authorization:
                "Bearer " + window.localStorage.getItem("token"),
        },
    }).then(response => {
        return response.data;
    }).catch(error => {
        console.log(error);
        if (error.response?.status >= 401) {
            window.localStorage.removeItem("token");
            window.localStorage.removeItem("userId");
            window.location.href = "/#/login";
        }
    });
}

function updateEntity(schemaName, entity) {
    return axios.put("/api/" + schemaName + "/" + entity.id, entity, {
        headers: {
            Authorization:
                "Bearer " + window.localStorage.getItem("token"),
        },
    }).then(response => {
        return response.data;
    }).catch(error => {
        console.log(error);
        if (error.response?.status >= 401) {
            window.localStorage.removeItem("token");
            window.localStorage.removeItem("userId");
            window.location.href = "/#/login";
        }
    });
}

function deleteEntity(schemaName, id) {
    return axios.delete("/api/" + schemaName + "/" + id, {
        headers: {
            Authorization:
                "Bearer " + window.localStorage.getItem("token"),
        },
    }).then(response => {
        return response.data;
    }).catch(error => {
        console.log(error);
        if (error.response?.status >= 401) {
            window.localStorage.removeItem("token");
            window.localStorage.removeItem("userId");
            window.location.href = "/#/login";
        }
    });
}

async function getSchemas() {
    const result = await axios
        .get("/api/admin/schemas", {
            headers: {
                Authorization:
                    "Bearer " + window.localStorage.getItem("token"),
            },
        }).catch(error => {
            console.log(error);
            if (error.response?.status >= 401) {
                window.localStorage.removeItem("token");
                window.localStorage.removeItem("userId");
                window.location.href = "/#/login";
            }
        });

    if (result.status === 200) {
        return result.data;
    }
}

async function getSchema(name) {
    const result = await axios
        .get(`/api/admin/schemas/${name}`, {
            headers: {
                Authorization:
                    "Bearer " + window.localStorage.getItem("token"),
            },
        }).catch(error => {
            console.log(error);
            if (error.response?.status >= 401) {
                window.localStorage.removeItem("token");
                window.localStorage.removeItem("userId");
                window.location.href = "/#/login";
            }
        });

    if (result.status === 200) {
        return result.data;
    }
}

export {
    getEntities,
    getEntity,
    getEntitiesAdmin,
    getEntityAdmin,
    createEntity,
    updateEntity,
    deleteEntity,
    getSchemas,
    getSchema
};
